import styled from 'styled-components';

export const DeviceConfigurationNameCellStyled = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: space-between;
`;

export const DeviceConfigurationTableContainer = styled.div`
    padding-bottom: 32px;
`;
